import {getSevDay} from "@utility/utils";

const data = getSevDay(0)

const initialState = {
    list: [],
    summary: {},
    dataList: [],
    loading: false,
    update_time: "",
    searchParams: {
        club_id: "",
        game_ids: "-1",
        round_types: "-1,1,2",
        start_date: data[0],
        end_date: data[1],
        refresh: false,
    }
}

const clubActive = (state = initialState, action) => {
    switch (action.type) {
        case 'CLUB_ACTIVE':
            return {
                ...state,
                ...action.payload
            }
        case 'CLUB_ACTIVE_INIT':
            return {
                ...initialState
            }
        default:
            return {...state};
    }
}

export default clubActive
